import React, {useState, useRef, useEffect} from "react";
import {Row, Col} from "antd";
import moment from "moment";
import ShiftSuggestionFilters from "./Components/ShiftSuggestionFilters";
import {useFetch} from "../../hooks/useFetch";
import stores from "../../store/stores";
import ShiftSuggestionTable from "./Components/ShiftSuggestionTable";
import ExcelButtons from "./Components/ExcelButtons";

const ShiftSuggestion = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [reloadData, setReloadData] = useState({});
    const [recall, setRecall] = useState(true);
    const recallRef = useRef(recall);
    recallRef.current = recall;

    useEffect(() => {
        let timeout = null;
        timeout = setTimeout(async () => {
            setRecall(!recallRef.current);
        }, 30000);
        return () => clearTimeout(timeout);
    }, [recall]);

    const [refresh, setRefresh] = useState(1);
    const [filters, setFilters] = useState({
        city: stores.meStore.auth.cities?.length == 1 ? stores.meStore.auth.cities[0] : undefined,
        company: undefined,
        subcompany: undefined,
        period: "choose",
        startDate: moment()
            .subtract(1, "d")
            .toDate(),
        endDate: moment()
            .add(3, "d")
            .toDate(),
        searchText: undefined,
        status: "all"
    });

    const [loading, data, setData, setLoading] = useFetch({
        fetchFn: stores.shiftSuggestionStore.getShiftSuggestionList.bind(null, {
            limit: 10,
            skip: (currentPage - 1) * 10,
            city: filters.city,
            company: filters.company,
            subcompany: filters.subcompany,
            period: filters.period,
            startDate: filters.startDate,
            endDate: filters.endDate,
            searchText: filters.searchText,
            status: filters.status,
            upperGroups: filters.upperGroups
        }),
        dependencies: [filters, currentPage, reloadData, refresh, recall]
    });
    return (
        <div>
            <Row gutter={[8, 8]}>
                <ShiftSuggestionFilters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row>
            <Row>
                <ExcelButtons
                    {...filters}
                    skip={(currentPage - 1) * 10}
                    limit={10}
                    recall={recall}
                    setReloadData={() => setReloadData(!reloadData)}
                />
            </Row>
            <Row>
                <ShiftSuggestionTable
                    setRefresh={setRefresh}
                    data={data?.result?.rows || []}
                    dataCount={data?.result?.dataCount}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setReloadData={() => setReloadData(!reloadData)}
                    loading={loading}
                />
            </Row>
        </div>
    );
};

export default ShiftSuggestion;
